import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setErrorAction } from "../store/reducers/commonSlice";
import { AuthService } from "../services/AuthService";
import endpoints from "../endpoints";
import IUserOption from "../types/userOption";
import { setUserOptionsAction } from "../store/reducers/userSlice";

export const userAPI = createApi({
  reducerPath: "userAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: `${endpoints.api}/users`,
    prepareHeaders: (headers: Headers) => {
      const token = AuthService.getToken() || "";
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
  }),
  tagTypes: ["userOptions"],
  endpoints: (builder) => ({
    getOptions: builder.query<IUserOption, void>({
      query: () => {
        return {
          url: "/options",
          method: "GET",
        };
      },
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled;
          if (data) {
            dispatch(
              setUserOptionsAction({
                skipInitialMessage: data.skipInitialMessage,
                addTalkPage: data.addTalkPage,
                excludedAccounts: data.excludedAccounts,
                revisionsStep: data.revisionsStep,
              })
            );
          }
        } catch (e: any) {
          if (e.error?.status === 401) {
            window.location.href = "/login";
          } else {
            dispatch(
              setErrorAction(
                e.error?.data?.message || "User options fetching error"
              )
            );
          }
        }
      },
      providesTags: ["userOptions"],
    }),

    updateOptions: builder.mutation<void, Partial<IUserOption>>({
      query: (data) => {
        return {
          url: "/options",
          method: "POST",
          body: {
            skip_initial_message: data.skipInitialMessage,
            add_talk_page: data.addTalkPage,
            excluded_accounts: data.excludedAccounts,
            revisions_step: data.revisionsStep,
          },
        };
      },
      invalidatesTags: ["userOptions"],
    }),
  }),
});
